import { useAccessRequestNodeFragment } from '@frameio/access-requests/gql/fragments/generated/AccessRequestNode';
import { NOTIFICATION_TYPE_ACCESS_REQUEST_SUBMITTED } from '../../../constants';
import { formatAccessRequestAvatar } from '../../../utils';
import type { NotificationGroupInfo } from '../types';
import { useAvatarsFragment } from './gql/generated/Avatars';

export function useAvatarsData({
  id,
  notificationType,
}: NotificationGroupInfo) {
  const isAccessRequest =
    notificationType === NOTIFICATION_TYPE_ACCESS_REQUEST_SUBMITTED;
  const {
    complete: completeNotificationAvatars,
    data: notificationAvatarsData,
  } = useAvatarsFragment({
    from: {
      id,
      __typename: notificationType,
      skip: isAccessRequest,
    },
  });

  const { complete: completeAccessRequest, data: accessRequestNodeData } =
    useAccessRequestNodeFragment({
      from: {
        id,
        __typename: 'AccessRequest',
        skip: !isAccessRequest,
      },
    });

  const complete = completeNotificationAvatars || completeAccessRequest;

  let avatars;
  if (isAccessRequest) {
    avatars = formatAccessRequestAvatar(accessRequestNodeData);
  } else if ('content' in notificationAvatarsData) {
    avatars = notificationAvatarsData?.content?.avatars;
  } else {
    avatars = null;
  }

  if (!complete || !avatars) return null;

  return {
    avatars,
  };
}
